// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","gallery":"bundle-gallery-v2_gallery__wTO83"};